/** values for type/@type that indicate an image content resource */
const imageTypes = ['Image', 'StillImage', 'dctypes:Image', 'dctypes:StillImage'];

/** values for type/@type that indicate a sound content resource */
const audioTypes = ['Audio', 'Sound', 'dctypes:Audio', 'dctypes:Sound'];

/** values for type/@type that indicate a choice resource */
const choiceTypes = ['oa:Choice'];

/** values for type/@type that indicate a text content resource */
const textTypes = ['Document', 'Text', 'dctypes:Document', 'dctypes:Text'];

/** values for type/@type that indicate a video content resource */
const videoTypes = ['Video', 'MovingImage', 'dctypes:Video', 'dctypes:MovingImage'];

export default {
  audioTypes,
  choiceTypes,
  imageTypes,
  textTypes,
  videoTypes,
};
